import { useState } from "react";
import {
    InsightsTeam,
    InsightsIndividual,
} from "store/api/investorCompany/interfaces";
import TabsGroup, { TabsGroupTab } from "components/TabsGroup";

// TABS
import TeamDynamicsTeamTab from "./Team";
import { TOOLTIPS } from "routes/company/tooltips";
import TeamDynamicsIndividualTab from "./Individual";
import InfoTooltip from "routes/company/components/InfoTooltip";

type Tabs = "team" | "individual";

type Props = {
    team: InsightsTeam;
    individual: InsightsIndividual;
};

const TeamDynamicsTab: React.FC<Props> = ({ team, individual }) => {
    const tabs: Array<TabsGroupTab<Tabs>> = [
        { label: "Team", value: "team" },
        { label: "Individual", value: "individual" },
    ];
    const [activeTab, setActiveTab] = useState<Tabs>(tabs[0].value);

    return (
        <div className="!w-[100%]">
            <div className="my-8 flex flex-row justify-between">
                <div className="flex flex-row items-center gap-1 text-lg">
                    Team Dynamics
                    <InfoTooltip text={TOOLTIPS.MAIN.teamDynamics} />
                </div>

                <TabsGroup<Tabs>
                    tabs={tabs}
                    activeTab={activeTab}
                    onClick={(tab) => setActiveTab(tab)}
                />
            </div>

            {activeTab === "team" && (
                <TeamDynamicsTeamTab
                    individualData={individual}
                    teamData={team}
                />
            )}
            {activeTab === "individual" && (
                <TeamDynamicsIndividualTab
                    individualData={individual}
                    teamData={team}
                />
            )}
        </div>
    );
};

export default TeamDynamicsTab;
